import { render, staticRenderFns } from "./BranchDisplayView.vue?vue&type=template&id=6bb75b3c"
import script from "./BranchDisplayView.vue?vue&type=script&lang=js"
export * from "./BranchDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports